/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */
import styled from '@emotion/styled';

import { token } from '@atlaskit/tokens';

export const PermissionsTableContainer = styled.div({
  '& th': {
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: token('space.300'),
  },
});

export const HeaderCheckbox = styled.span({
  verticalAlign: 'bottom',
});

export const GroupAvatarContainer = styled.div({
  background: token('color.background.accent.gray.subtler'),
  borderRadius: '50%',
  border: `${token('space.025')} solid ${token('color.border.inverse')}`,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: token('space.400'),
  height: token('space.400'),
});

export const TextFieldSection = styled.div({
  marginBottom: token('space.200'),
  marginTop: token('space.150'),
  display: 'flex',
  alignItems: 'center',
  '& > div:nth-of-type(1)': {
    marginRight: token('space.200'),
  },
});

export const BulkActionsHeader = styled.div({
  display: 'flex',
  alignItems: 'center',
  color: token('color.text.subtle'),
  font: token('font.body'),
  '& button:nth-of-type(2), & button:nth-of-type(3)': {
    marginLeft: token('space.150'),
  },
});

export const DetailsTableWrapper = styled.div({
  tbody: {
    borderBottom: `${token('space.025')} solid ${token('color.border')}`,
    '> tr': {
      height: token('space.500'),
    },
  },
});

export const DetailsTableFooter = styled.div<{ isDisabled?: boolean }>(
  ({ isDisabled }) => ({
    display: 'flex',
    justifyContent: 'space-between',
    paddingBottom: token('space.200'),
    marginBottom: token('space.800'),
    pointerEvents: isDisabled ? 'none' : 'auto',
    opacity: isDisabled ? '0.5' : '1',
  })
);

export const DetailsTablePaginationWrapper = styled.div({
  flex: 1,
  display: 'flex',
  justifyContent: 'center',
});

export const PrivilegesDropdownText = styled.span({
  display: 'inline-flex',
  padding: `0 ${token('space.150')}`,
  alignItems: 'center',
  cursor: 'default',
});

export const PrivilegeWithIcon = styled.div({
  display: 'inline-flex',
  alignItems: 'center',
  "[role='img']": {
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: 'inherit',
  },
});
